/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис управления настройками Face Recognition
 */

/**
 * Сервис управления настройками Face Recognition
 */
export class FacerecServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод редактирования настроек Face Recognition
   */
  EditFacerec = (req: Pick<EditFacerecRequestDto, "updateMask"> & { data: FacerecRequestDto & fm.RequireAtLeastOne<FacerecRequestDto> }, init?: RequestInit): Promise<EditFacerecResponseDto> => {
    return fm.request<Pick<EditFacerecRequestDto, "updateMask"> & { data: FacerecRequestDto & fm.RequireAtLeastOne<FacerecRequestDto> }, EditFacerecResponseDto>(`${this.host}/device/api/v1/facerec`, { ...init, method: "PATCH", body: JSON.stringify(req.data, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения настроек Face Recognition
   */
  GetFacerec = (req?: GetFacerecRequestDto, init?: RequestInit): Promise<GetFacerecResponseDto> => {
    return fm.request<GetFacerecRequestDto, GetFacerecResponseDto>(`${this.host}/device/api/v1/facerec${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос редактирования настроек Face Recognition
 */
export type EditFacerecRequestDto = {
  /**
   * Настройки Face Recognition
   */
  data: FacerecRequestDto
  /**
   * Маска полей обновления
   */
  updateMask?: string | null
}
/**
 * Ответ на запрос редактирования настроек Face Recognition
 */
export type EditFacerecResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: EditFacerecResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type EditFacerecResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type EditFacerecResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Настройки Face Recognition
 */
export type FacerecRequestDto = {
  /**
   * Флаг включения Face Recognition
   */
  isEnabled: boolean
  /**
   * Адрес
   */
  mainAddress: string
  /**
   * Альтернативный адрес
   */
  altAddress?: string
  /**
   * Путь запроса к серверу
   */
  request: string
  /**
   * Токен
   */
  authorization: string
  /**
   * Идентификаторы групп профилей в identix
   */
  groups?: string[]
  /**
   * Индекс реле.
   * Диапазон: 1..32767
   */
  relayIndex?: number
  /**
   * Интервал отправки, миллисекунд
   */
  sendInterval?: number
  /**
   * Доступность FR
   */
  faceLiveness?: number
  /**
   * Минимальный размер лица, пикселей
   */
  minFaceSize?: number
  /**
   * Максимальный размер лица, пикселей
   */
  maxFaceSize?: number
  /**
   * Добавление размера, процентов
   */
  addSize?: number
}
/**
 * Настройки Face Recognition
 */
export type FacerecResponseDto = {
  /**
   * Флаг включения Face Recognition
   */
  isEnabled: boolean
  /**
   * Адрес
   */
  mainAddress: string
  /**
   * Альтернативный адрес
   */
  altAddress: string
  /**
   * Путь запроса к серверу
   */
  request: string
  /**
   * Токен
   */
  authorization: string
  /**
   * Идентификаторы групп профилей в identix
   */
  groups: string[]
  /**
   * Индекс реле.
   * Диапазон: 1..32767
   */
  relayIndex: number
  /**
   * Интервал отправки, миллисекунд
   */
  sendInterval: number
  /**
   * Доступность FR
   */
  faceLiveness: number
  /**
   * Минимальный размер лица, пикселей
   */
  minFaceSize: number
  /**
   * Максимальный размер лица, пикселей
   */
  maxFaceSize: number
  /**
   * Добавление размера, процентов
   */
  addSize: number
}
/**
 * Запрос получения настроек Face Recognition
 */
export type GetFacerecRequestDto = {
}
/**
 * Ответ на запрос получения настроек Face Recognition
 */
export type GetFacerecResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки Face Recognition
   */
  readonly data: FacerecResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос редактирования настроек Face Recognition
   */
  "EditFacerecRequest": {
    "kind": "class",
    "text": "Запрос редактирования настроек Face Recognition",
    "fields": {
      /**
       * Настройки Face Recognition
       */
      "data": {
        "type": "Facerec",
        "text": "Настройки Face Recognition",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Маска полей обновления
       */
      "updateMask": {
        "type": "google.protobuf.FieldMask",
        "text": "Маска полей обновления",
      },
    },
  },
  /**
   * Ответ на запрос редактирования настроек Face Recognition
   */
  "EditFacerecResponse": {
    "kind": "class",
    "text": "Ответ на запрос редактирования настроек Face Recognition",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "EditFacerecResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "EditFacerecResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Настройки Face Recognition
   */
  "Facerec": {
    "kind": "class",
    "text": "Настройки Face Recognition",
    "fields": {
      /**
       * Флаг включения Face Recognition
       */
      "isEnabled": {
        "type": "bool",
        "text": "Флаг включения Face Recognition",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Адрес
       */
      "mainAddress": {
        "type": "string",
        "text": "Адрес",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Альтернативный адрес
       */
      "altAddress": {
        "type": "string",
        "text": "Альтернативный адрес",
      },
      /**
       * Путь запроса к серверу
       */
      "request": {
        "type": "string",
        "text": "Путь запроса к серверу",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Токен
       */
      "authorization": {
        "type": "string",
        "text": "Токен",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификаторы групп профилей в identix
       */
      "groups": {
        "type": "string",
        "text": "Идентификаторы групп профилей в identix",
      },
      /**
       * Индекс реле.
       * Диапазон: 1..32767
       */
      "relayIndex": {
        "type": "int32",
        "text": "Индекс реле.\nДиапазон: 1..32767",
      },
      /**
       * Интервал отправки, миллисекунд
       */
      "sendInterval": {
        "type": "int32",
        "text": "Интервал отправки, миллисекунд",
      },
      /**
       * Доступность FR
       */
      "faceLiveness": {
        "type": "float",
        "text": "Доступность FR",
      },
      /**
       * Минимальный размер лица, пикселей
       */
      "minFaceSize": {
        "type": "int32",
        "text": "Минимальный размер лица, пикселей",
      },
      /**
       * Максимальный размер лица, пикселей
       */
      "maxFaceSize": {
        "type": "int32",
        "text": "Максимальный размер лица, пикселей",
      },
      /**
       * Добавление размера, процентов
       */
      "addSize": {
        "type": "int32",
        "text": "Добавление размера, процентов",
      },
    },
  },
  /**
   * Запрос получения настроек Face Recognition
   */
  "GetFacerecRequest": {
    "kind": "class",
    "text": "Запрос получения настроек Face Recognition",
  },
  /**
   * Ответ на запрос получения настроек Face Recognition
   */
  "GetFacerecResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения настроек Face Recognition",
    "fields": {
      /**
       * Настройки Face Recognition
       */
      "data": {
        "type": "Facerec",
        "text": "Настройки Face Recognition",
      },
    },
  },
}